export const ADD_CART = "ADD_CART";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_LOADING = "SET_lOADING";
